export default __webpack_public_path__ + "static/media/accessories-1.1eac0aca.jfif";